'use client';

import { useCallback } from 'react';
import { tracking } from '@/hotdesk-ui/services/tracking.service';
import type { CompareType } from '@/hotdesk-ui/enum/compare';

type CompareEventParams = Record<string, string | number | boolean | null | undefined>;

/**
 * Every compare event carries `compare_type` and `items_count` (PRD § Tracking).
 * Pass the current count so it is right at the moment the event fires.
 */
export function useCompareTracking(compareType: CompareType) {
    return useCallback(
        (
            eventName: `compare_${string}`,
            itemsCount: number,
            params: CompareEventParams = {}
        ) => {
            tracking.onCompareEvent(eventName, {
                compare_type: compareType,
                items_count: itemsCount,
                ...params
            });
        },
        [compareType]
    );
}

export default useCompareTracking;
